/*
 * @FileAuthor: ghy
 * @Date: 2024-07-10 14:27:38
 * @Description: qspace中间件
 */

class MiddleWare {
  constructor(qspace) {
    this.qspace = qspace;
    this.commonEvents = qspace.commonEvents;
    this.commonExtension = qspace.commonExtension;
  }
  getCurrentMode() {
    return this.qspace.view.mode;
  }
  getActiveModelType() {
    return this.qspace.model.type;
  }
  getCurrentLocationId() {
    return this.qspace.model.waypoint;
  }
  getWaypointPosition(id) {
    return this.qspace.model.getWaypointPosition(id);
  }
  getBoundingBox() {
    return this.qspace.model.getBoundingBox();
  }
  sceneAdd(obj) {
    this.qspace.scene.add(obj);
  }
  sceneRemove(obj) {
    this.qspace.scene.remove(obj);
  }
  getQuaternion() {
    // return this.qspace.floorplanCamera.quaternion;
    return this.qspace.dollhouseCamera.quaternion;
  }

  get NEED_MODE_CHANGE() {
    return this.commonExtension.API.NEED_MODE_CHANGE;
  }
  get NEED_SWITCH_MODEL() {
    return this.commonExtension.API.NEED_SWITCH_MODEL;
  }
  get NEED_SWITCH_MODEL_COMPLETE() {
    return this.commonExtension.API.NEED_SWITCH_MODEL_COMPLETE;
  }
  get NEED_SWITCH_WAYPOINT_START() {
    return this.commonExtension.API.NEED_SWITCH_WAYPOINT_START;
  }
  get NEED_UPDATE() {
    return this.commonExtension.API.NEED_UPDATE;
  }
  get NEED_PANORAMA_CAMERA_ROTATE() {
    return this.commonExtension.API.NEED_PANORAMA_CAMERA_ROTATE;
  }
}

module.exports = MiddleWare;
